// extracted by mini-css-extract-plugin
module.exports = {"container":"WKCQUQBnN0n9zC5FnEP6u","groupsList":"KT63WXRZjL3mCf00go8Ai"};